<template>
    <b-table-simple responsive borderless>
        <b-thead>
            <b-tr>
                <b-th style="min-width: 14rem">Total Assets</b-th>
                <b-th style="width: 8rem">Before (RM)</b-th>
                <b-th style="min-width: 8rem">After (RM)</b-th>
            </b-tr>
        </b-thead>
        <b-tbody>
            <!-- Cash/Cash Equiv. Start -->
            <b-tr class="border-bottom-0">
                <b-td colspan="3">
                    Cash/Cash Equivalents
                    <span class="cursor-pointer text-primary" @click.prevent="addAsset('cash_equivalents')">+ Add</span>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0 border-bottom-0"  v-for="(cash_equivalent, index) in form_data.cash_equivalents" :key="'cash_equivalent_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="cash_equivalent.asset_title"></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="cash_equivalent.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="cash_equivalent.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('cash_equivalents', cash_equivalent)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0">
                <b-td>
                    <p class="font-weight-600">Total Cash/Cash Equiv.</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.cash_equivalents.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.cash_equivalents.customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.cash_equivalents.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.cash_equivalents.admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Cash/Cash Equiv. End -->

            <!-- Investment Assets Start -->
            <b-tr class="border-bottom-0">
                <b-td colspan="3">
                    Investment Assets
                    <span class="cursor-pointer text-primary" @click.prevent="addAsset('investment_assets')">+ Add</span>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0 border-bottom-0"  v-for="(investment_asset, index) in form_data.investment_assets" :key="'investment_asset_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="investment_asset.asset_title"></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="investment_asset.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="investment_asset.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('investment_assets', investment_asset)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0">
                <b-td>
                    <p class="font-weight-600">Total Investment Assets </p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.investment_assets.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.investment_assets.customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.investment_assets.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.investment_assets.admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Investment Assets End -->

            <!-- Personal Assets Start -->
            <b-tr class="border-bottom-0">
                <b-td colspan="3">
                    Personal Assets
                    <span class="cursor-pointer text-primary" @click.prevent="addAsset('personal_assets')">+ Add</span>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0 border-bottom-0"  v-for="(personal_asset, index) in form_data.personal_assets" :key="'personal_asset_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="personal_asset.asset_title"></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="personal_asset.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="personal_asset.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('personal_assets', personal_asset)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0">
                <b-td>
                    <p class="font-weight-600">Total Personal Assets</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.personal_assets.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.personal_assets.customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.personal_assets.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.personal_assets.admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Personal Assets End -->

            <!-- Total EPF Account 1 Start -->
            <b-tr class="border-top-0 border-bottom-0"  v-for="(epf_account, index) in form_data.epf_account_1" :key="'epf_account_1_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="epf_account.asset_title" disabled></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="epf_account.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="epf_account.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('epf_account_1', epf_account)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0" v-if="form_data.epf_account_1">
                <b-td>
                    <p class="font-weight-600">Total EPF Account 1 </p>
                </b-td>
                <b-td>
                    <p class="font-weight-600">{{ form_data.epf_account_1[0].customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600">{{ form_data.epf_account_1[0].admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Total EPF Account 1 End -->

            <!-- Total EPF Account 2 Start -->
            <b-tr class="border-top-0 border-bottom-0"  v-for="(epf_account, index) in form_data.epf_account_2" :key="'epf_account_2_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="epf_account.asset_title" disabled></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="epf_account.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="epf_account.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('epf_account_2', epf_account)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0" v-if="form_data.epf_account_2">
                <b-td>
                    <p class="font-weight-600">Total EPF Account 2 </p>
                </b-td>
                <b-td>
                    <p class="font-weight-600">{{ form_data.epf_account_2[0].customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600">{{ form_data.epf_account_2[0].admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Total EPF Account 2 End -->

            <!-- Total Insurance Sur. Value Start -->
            <b-tr class="border-bottom-0">
                <b-td colspan="3">
                    Insurances
                    <span class="cursor-pointer text-primary" @click.prevent="addAsset('insurances')">+ Add</span>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0 border-bottom-0"  v-for="(insurance, index) in form_data.insurances" :key="'insurance_'+index">
                <b-td>
                    <b-form-group class="mb-0">
                        <b-form-input type="text" v-model="insurance.asset_title"></b-form-input>
                    </b-form-group>
                </b-td>
                <b-td>
                    <b-form-group class="mb-0">
                        <CurrencyInput
                            v-model="insurance.customer_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-td>
                <b-td>
                    <div class="d-flex">
                        <b-form-group class="mb-0">
                            <CurrencyInput
                                v-model="insurance.admin_value"
                                :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                            />
                        </b-form-group>
                        <svg xmlns="http://www.w3.org/2000/svg" @click.prevent="removeAsset('insurances', insurance)" class="cursor-pointer" width="16" height="20" viewBox="0 0 384 512"><path fill="#DF3030" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"/></svg>
                    </div>
                </b-td>
            </b-tr>
            <b-tr class="border-top-0">
                <b-td>
                    <p class="font-weight-600">Total Insurance Sur. Value </p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.insurances.customer_value < 0 ? '#f5365c' : ''}">{{ form_data_total.insurances.customer_value | moneyFormatter }}</p>
                </b-td>
                <b-td>
                    <p class="font-weight-600" :style="{'color': form_data_total.insurances.admin_value < 0 ? '#f5365c' : ''}">{{ form_data_total.insurances.admin_value | moneyFormatter }}</p>
                </b-td>
            </b-tr>
            <!-- Total Insurance Sur. Value End -->
        </b-tbody>
        <b-tfoot>
            <b-tr class="font-weight-600">
                <b-td>Total</b-td>
                <b-td>{{ form_data_total.total_asset_customer_value | moneyFormatter }}</b-td>
                <b-td>{{ form_data_total.total_asset_admin_value | moneyFormatter }}</b-td>
            </b-tr>
            <br>
            <b-button block variant="primary" @click="saveCustomerAsset">Save</b-button>
        </b-tfoot>
    </b-table-simple>
</template>
<script>
import { Select, Option } from 'element-ui'
import CurrencyInput from '@/components/CurrencyInput'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { useCustomerStore } from '@/stores/customerStore'
import { mapState } from 'pinia'

export default {
    props: ['proposal', 'current_customer'],
    mixins: ['notifyFunctionMixin'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        CurrencyInput,
    },
    computed:{
    },
    watch: {
        form_data: {
            handler(newVal) {
                if(newVal)
                {
                    this.calculateTotalAsset();
                }
            },
            deep: true,
        },
        'form_data.cash_equivalents': {
            handler(newVal) {
                if(newVal)
                {   
                    this.form_data_total.cash_equivalents = {
                        customer_value: newVal.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: newVal.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }
            },
            immediate: true,
            deep: true,
        },
        'form_data.investment_assets': {
            handler(newVal) {
                if(newVal)
                {
                    this.form_data_total.investment_assets = {
                        customer_value: newVal.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: newVal.reduce((acc, item) => acc + item.admin_value, 0),
                    }
                }
            },
            deep: true,
        },
        'form_data.personal_assets': {
            handler(newVal) {
                if(newVal)
                {
                    this.form_data_total.personal_assets = {
                        customer_value: newVal.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: newVal.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }
            },
            deep: true,
        },
        'form_data.insurances': {
            handler(newVal) {
                if(newVal)
                {
                    this.form_data_total.insurances = {
                        customer_value: newVal.reduce((acc, item) => acc + item.customer_value, 0),
                        admin_value: newVal.reduce((acc, item) => acc + item.admin_value, 0),
                    };
                }
            },
            deep: true,
        }
    },
    data() {
        return {
            form_data: {
                cash_equivalents: [],
                investment_assets: [],
                personal_assets: [],
                epf_account_1: [
                    {
                        asset_type_id: 4,
                        customer_asset_id: null,
                        asset_title:  'EPF Account 1',
                        customer_value: null,
                        admin_value: null
                    }
                ],
                epf_account_2: [
                    {
                        asset_type_id: 5,
                        customer_asset_id: null,
                        asset_title:  'EPF Account 2',
                        customer_value: null,
                        admin_value: null
                    }
                ],
                insurances: [],
            },
            form_data_total: {
                cash_equivalents: {
                    customer_value: null,
                    admin_value: null,
                },
                investment_assets: {
                    customer_value: null,
                    admin_value: null,
                },
                personal_assets: {
                    customer_value: null,
                    admin_value: null,
                },
                insurances: {
                    customer_value: null,
                    admin_value: null,
                },
                total_asset_customer_value: null,
                total_asset_admin_value: null,
            },
            cash_equivalents: {
                name:  'Savings from net flow',
                amount_before: -3433,
                amount_after: -3433
            },
            personal_assets: {
                name:  'Car value (23 Feb ‘23)',
                amount_before: 20000,
                amount_after: 25000
            }
        }
    },
    created() {
        this.getCustomerAssets();
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        calculateTotalAsset() {
            this.form_data_total.total_asset_customer_value = 0;
            this.form_data_total.total_asset_admin_value = 0;
            for (const key in this.form_data) {
                if (Array.isArray(this.form_data[key])) {
                    this.form_data[key].forEach(item => {
                        if (item && typeof item.customer_value === 'number') {
                            this.form_data_total.total_asset_customer_value += item.customer_value;
                        }
                        if (item && typeof item.admin_value === 'number') {
                            this.form_data_total.total_asset_admin_value += item.admin_value;
                        }
                    });
                }
            }
        },
        removeAsset(asset_type, item) {
            switch(asset_type)
            {
                case 'cash_equivalents':
                    var index = this.form_data.cash_equivalents.indexOf(item);
                    this.form_data.cash_equivalents.splice(index, 1);
                    break;
                case 'investment_assets':
                    var index = this.form_data.investment_assets.indexOf(item);
                    this.form_data.investment_assets.splice(index, 1);
                    break;
                case 'personal_assets':
                    var index = this.form_data.personal_assets.indexOf(item);
                    this.form_data.personal_assets.splice(index, 1);
                    break;
                case 'epf_account_1':
                    this.form_data.epf_account_1[0].customer_value = null;
                    this.form_data.epf_account_1[0].admin_value = null;
                    break;
                case 'epf_account_2':
                    this.form_data.epf_account_2[0].customer_value = null;
                    this.form_data.epf_account_2[0].admin_value = null;
                    break;
                case 'insurances':
                    var index = this.form_data.insurances.indexOf(item);
                    this.form_data.insurances.splice(index, 1);
                    break;
            }
        },
        addAsset(asset_type) {
            switch(asset_type)
            {
                case 'cash_equivalents':
                    this.form_data.cash_equivalents.push(
                        {
                            asset_type_id: 1,
                            customer_asset_id: null,
                            asset_title: null,
                            customer_value: null,
                            admin_value: null,
                        }
                    );
                    break;
                case 'investment_assets':
                    this.form_data.investment_assets.push(
                        {
                            asset_type_id: 2,
                            customer_asset_id: null,
                            asset_title: null,
                            customer_value: null,
                            admin_value: null,
                        }
                    );
                    break;
                case 'personal_assets':
                    this.form_data.personal_assets.push(
                        {
                            asset_type_id: 3,
                            customer_asset_id: null,
                            asset_title: null,
                            customer_value: null,
                            admin_value: null,
                        }
                    );
                    break;
                case 'insurances':
                    this.form_data.insurances.push(
                        {
                            asset_type_id: 6,
                            customer_asset_id: null,
                            asset_title: null,
                            customer_value: null,
                            admin_value: null,
                        }
                    );
                    break;
            }
        },
        saveCustomerAsset() {
            const postData = {
                im2u_customer_id: this.current_customer.customer_id,
                psal_id: this.proposal.psal_id,
                ssa_id: this.current_customer.ssa != null ? this.current_customer.ssa.id : null,
                sse_id: this.current_customer.sse != null ? this.current_customer.sse.id : null,
                se_id: this.current_customer.se != null ? this.current_customer.se.id : null,
                customer_name: this.current_customer.name,
                customer_email: this.current_customer.email,
                customer_nric: this.current_customer.nric,
                agent_name: this.current_customer.se != null ? this.current_customer.se.name : this.current_customer.sse != null ? this.current_customer.sse.name : null,
                agent_email: this.current_customer.se != null ? this.current_customer.se.email : this.current_customer.sse != null ? this.current_customer.sse.email : null,
                agent_contact_number: this.current_customer.se != null ? this.current_customer.se.name : this.current_customer.sse != null ? this.current_customer.sse.name : null,
                customer_assets: this.form_data,
            };

            axios.post(services.financial_proposal + 'customer_asset', postData, {headers: getHeader()} )
            .then(res=>{
                this.form_data = res.data.data;
                this.getCustomerAssets();
                this.$notify({
                    message: "<b>Customer Asset </b> - Successfully Updated.",
                    timeout: 1000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                });
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        getCustomerAssets() {
            axios.get(services.financial_proposal + 'get_customer_asset_by_customer_id_and_proposal_id/' + this.current_customer.customer_id + '/' + this.proposal.psal_id, {headers: getHeader()} )
            .then(res=>{
                if(res.data.data.length !== 0)
                {
                    // this.form_data = res.data.data;
                    this.form_data.cash_equivalents = res.data.data.cash_equivalents ?? [];
                    this.form_data.investment_assets = res.data.data.investment_assets ?? [];
                    this.form_data.personal_assets = res.data.data.personal_assets ?? [];
                    this.form_data.epf_account_1 = res.data.data.epf_account_1 ?? [
                        {
                            asset_type_id: 4,
                            customer_asset_id: null,
                            asset_title:  'EPF Account 1',
                            customer_value: null,
                            admin_value: null
                        }
                    ];
                    this.form_data.epf_account_2 = res.data.data.epf_account_2 ?? [
                        {
                            asset_type_id: 5,
                            customer_asset_id: null,
                            asset_title:  'EPF Account 2',
                            customer_value: null,
                            admin_value: null
                        }
                    ];
                    this.form_data.insurances = res.data.data.insurances ?? [];
                }
                const customer_assets = {
                    data: res.data.data,
                    total: this.form_data_total,
                }
                this.$notify({
                    message: "<b>Customer Asset Details </b> - Successfully Obtained.",
                    timeout: 1000,
                    icon: 'ni ni-bell-55',
                    type: 'default',
                });
            })
            .catch(e => {
                // console.log(e);
                this.errorFunction(e)
            })
        }
    }
}
</script>